export default __webpack_public_path__ + "static/media/modalImageOne.4a166a93.webp";